<template>
  <section class="till-payments-section">
    <v-alert type="info" :value="showInfo" transition="slide-x-transition">
      Les montants de débit, visa et master doivent être rentré sans les
      pourboires!
      <br />
      Ces montants se trouvent sur le rapport de fermeture du TPV.
    </v-alert>
    <v-row dense>
      <v-col cols="12" sm="4">
        <j-decimal-input
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="debit"
          label="Debit"
          type="number"
          min="0"
          step="0.01"
          @input="e => updateProps('debit', Number(e))"
          class="no-before"
        ></j-decimal-input
      ></v-col>
      <v-col cols="12" sm="4">
        <j-decimal-input
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="visa"
          label="Visa"
          type="number"
          min="0"
          step="0.01"
          @input="e => updateProps('visa', Number(e))"
          class="no-before"
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="4">
        <j-decimal-input
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="master"
          label="Master"
          type="number"
          min="0"
          step="0.01"
          @input="e => updateProps('master', Number(e))"
          class="no-before"
        ></j-decimal-input>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="4">
        <j-decimal-input
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="certificat"
          label="Certificats cadeaux"
          type="number"
          min="0"
          step="0.01"
          @input="e => updateProps('certificat', Number(e))"
          class="no-before"
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="4">
        <j-decimal-input
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="client"
          label="Comptes clients"
          type="number"
          min="0"
          step="0.01"
          @input="e => updateProps('client', Number(e))"
          class="no-before"
        ></j-decimal-input
      ></v-col>
      <v-col cols="12" sm="4">
        <j-decimal-input
          filled
          dense
          hide-details
          :read-only="readOnly"
          :value="others"
          label="Autres"
          type="number"
          min="0"
          step="0.01"
          @input="e => updateProps('others', Number(e))"
          class="no-before"
        ></j-decimal-input>
      </v-col>
    </v-row>
    <v-alert :value="cash < 0" type="error" transition="slide-y-transition">
      Le montant des paiments excluants l'argent comptant excède le total des
      ventes!
      <br />
      Vérifier le montant des paiements ou des ventes.
    </v-alert>
  </section>
</template>

<script>
import round10 from "round10";
export default {
  name: "TillPayments",
  props: {
    cash: {
      required: true
    },
    debit: {
      required: true
    },
    visa: {
      required: true
    },
    master: {
      required: true
    },
    certificat: {
      required: true
    },
    client: {
      required: true
    },
    others: {
      required: true
    },
    valid: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalPaymentsWithoutCash() {
      return round10.round10(
        this.debit +
          this.master +
          this.visa +
          this.certificat +
          this.client +
          this.others,
        -2
      );
    }
  },
  methods: {
    updateProps(type, value) {
      this.$emit(`update:${type}`, round10.round10(Math.abs(value), -2));
    }
  },
  watch: {
    cash(v) {
      this.$emit("update:valid", v > 0 && this.totalPaymentsWithoutCash > 0);
    }
  }
};
</script>

<style scoped></style>
